import {
  // eslint-disable-next-line no-restricted-imports
  DateInput as MantineDateInput,
  // eslint-disable-next-line no-restricted-imports
  type DateInputProps as MantineDateInputProps
} from "@mantine/dates";
import { DateTime } from "luxon";
import { parseManualDateInput } from "../../../utils/parseManualDateInput";

interface DateInputProps extends Omit<
  MantineDateInputProps,
  | "defaultDate"
  | "defaultValue"
  | "date"
  | "minDate"
  | "maxDate"
  | "type"
  | "value"
  | "onChange"
> {
  initialCalendarDate?: DateTime;
  defaultValue?: DateTime;
  minDate?: DateTime;
  maxDate?: DateTime;
  value?: DateTime | null;
  onChange?: (date: DateTime | null) => void;
}

function DateInput({
  initialCalendarDate,
  defaultValue,
  minDate,
  maxDate,
  value,
  onChange,
  ...dateInputProps
}: DateInputProps) {
  const parsedInitialCalendarDate: Date | undefined =
    initialCalendarDate?.toJSDate();
  const parsedValue: Date | null | undefined =
    value === undefined ? undefined : (value?.toJSDate() ?? null);
  const parsedMin: Date | undefined = minDate?.toJSDate();
  const parsedMax: Date | undefined = maxDate?.toJSDate();
  const parsedDefault: Date | undefined = defaultValue?.toJSDate();

  function handleChange(value: string | null) {
    onChange?.(value ? DateTime.fromISO(value) : null);
  }

  return (
    <MantineDateInput
      {...dateInputProps}
      dateParser={parseManualDateInput}
      defaultDate={parsedInitialCalendarDate}
      defaultValue={parsedDefault}
      maxDate={parsedMax}
      minDate={parsedMin}
      value={parsedValue}
      onChange={handleChange}
    />
  );
}

export { DateInput, DateInputProps };
